import { toCurrency } from '@itrustcapital/ui';

export function toCurrencyDisplay(value: number, ticker: string): string | number {
	if (!value) {
		return 0;
	}

	return toCurrency(value, {
		showDollar: ticker === 'USD',
	});
}
